import React from 'react';
import {CreateGuesser} from "@api-platform/admin";

const CityCreate = (props) => {
    return (
            <CreateGuesser {...props}/>
    );
};

export default CityCreate;
